export const frCommonActions = {
    'commons.actions.ok': 'OK',
    'commons.actions.validate': 'Valider',
    'commons.actions.cancel': 'Annuler',
    'commons.actions.save': 'Enregistrer',
    'commons.actions.create': 'Créer',
    'commons.actions.remove': 'Supprimer',
    'commons.actions.clone': 'Dupliquer',
    'commons.actions.close': 'Fermer',
    'commons.actions.delete_all': 'Tout supprimer',
    'commons.actions.exportExcel': 'Export Excel',
    'commons.actions.exportExcel.loading': 'Export en cours...',
    'commons.actions.importExcel': 'Import Excel',
    'commons.actions.importExcel.loading': 'Import en cours...',
    'commons.actions.cancelCreation': 'Annuler la création',
    'commons.actions.activate': 'Activer',
    'commons.actions.deactivate': 'Désactiver',
    'commons.actions.publish': 'Publier',
    'commons.actions.disable': 'Désactiver',
    'commons.actions.modify': 'Modifier',
};
